/**
 * @since 0.0.4
 * 
 * @param {Object} store The nuxtjs store
 * @param {String} key 
 * @param {String} fallback 
 * @returns 
 */
export default function translate(store, key, fallback = '') {
    if(!store.state || !store.state.translations) {
        return fallback;
    }

    return store.state.translations[key] || fallback;
}